export const esNotifications = {
  'notifications.activity': 'Tu actividad',
  'notifications.activityCenter': 'Centro de actividad',
  'notifications.clear': 'Vaciar',
  'notifications.delete': 'Eliminar {title}',
  'notifications.description':
    'Consulta avisos financieros y controla qué dispositivos pueden recibir alertas.',
  'notifications.deviceAlerts': 'Alertas del dispositivo',
  'notifications.disable': 'Desactivar aquí',
  'notifications.disableError': 'No pudimos desactivar este dispositivo.',
  'notifications.empty': 'Todo está tranquilo',
  'notifications.emptyDescription': 'Las alertas de pagos, recordatorios y bancos aparecerán aquí.',
  'notifications.enable': 'Activar en este dispositivo',
  'notifications.enableError': 'No pudimos activar las notificaciones en este dispositivo.',
  'notifications.loadError': 'No pudimos cargar tus notificaciones.',
  'notifications.localActive': 'Este dispositivo está listo para recibir alertas de FinanceGo.',
  'notifications.markRead': 'Marcar leídas',
  'notifications.otherActive': 'Ya tienes alertas activas en otro dispositivo.',
  'notifications.push': 'Notificaciones push',
  'notifications.pushDescription':
    'Actívalas para recibir recordatorios incluso cuando la app esté cerrada.',
  'notifications.readError': 'No pudimos leer la configuración push de este dispositivo.',
  'notifications.recent': 'Notificaciones recientes',
  'notifications.sendTest': 'Enviar prueba',
  'notifications.testSent': 'Prueba enviada a {count} dispositivo(s).',
  'notifications.title': 'Lo importante, cuando importa.',
  'notifications.unsupported': 'Este navegador no admite Web Push.',
} as const;

export const enNotifications: Record<keyof typeof esNotifications, string> = {
  'notifications.activity': 'Your activity',
  'notifications.activityCenter': 'Activity center',
  'notifications.clear': 'Clear',
  'notifications.delete': 'Delete {title}',
  'notifications.description':
    'Review financial notices and control which devices can receive alerts.',
  'notifications.deviceAlerts': 'Device alerts',
  'notifications.disable': 'Disable here',
  'notifications.disableError': 'We could not disable this device.',
  'notifications.empty': 'Everything is quiet',
  'notifications.emptyDescription': 'Payment, reminder, and bank alerts will appear here.',
  'notifications.enable': 'Enable on this device',
  'notifications.enableError': 'We could not enable notifications on this device.',
  'notifications.loadError': 'We could not load your notifications.',
  'notifications.localActive': 'This device is ready to receive FinanceGo alerts.',
  'notifications.markRead': 'Mark as read',
  'notifications.otherActive': 'You already have alerts enabled on another device.',
  'notifications.push': 'Push notifications',
  'notifications.pushDescription': 'Enable them to receive reminders even when the app is closed.',
  'notifications.readError': 'We could not read push settings for this device.',
  'notifications.recent': 'Recent notifications',
  'notifications.sendTest': 'Send test',
  'notifications.testSent': 'Test sent to {count} device(s).',
  'notifications.title': 'What matters, when it matters.',
  'notifications.unsupported': 'This browser does not support Web Push.',
};
